var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-margin": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            { attrs: { tag: "w-container" } },
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "w-card",
                        { attrs: { grow: "", shrink: "" } },
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("reports"))),
                          ]),
                          _c(
                            "w-card-content",
                            [
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          label: _vm.$ct("print-date"),
                                          space: "",
                                        },
                                        model: {
                                          value: _vm.config.PrintDateOnEachPage,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.config,
                                              "PrintDateOnEachPage",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "config.PrintDateOnEachPage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          label: _vm.$ct("print-page-numbers"),
                                          space: "",
                                        },
                                        model: {
                                          value: _vm.config.PrintPageNumbers,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.config,
                                              "PrintPageNumbers",
                                              $$v
                                            )
                                          },
                                          expression: "config.PrintPageNumbers",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c("app-document-page-settings-font", {
                        model: {
                          value: _vm.config.PageSettings,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "PageSettings", $$v)
                          },
                          expression: "config.PageSettings",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c("app-document-page-settings-default", {
                        model: {
                          value: _vm.config.PageSettings,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "PageSettings", $$v)
                          },
                          expression: "config.PageSettings",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c("app-document-page-settings-background-image", {
                        model: {
                          value: _vm.config.PageSettings,
                          callback: function ($$v) {
                            _vm.$set(_vm.config, "PageSettings", $$v)
                          },
                          expression: "config.PageSettings",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { md: "6" } },
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("heading"))),
                          ]),
                          _c(
                            "w-card-content",
                            [
                              _c(
                                "w-row",
                                _vm._l(
                                  _vm.config.Heading.getHeadings(),
                                  function (heading, i) {
                                    return _c(
                                      "w-col",
                                      { key: i, attrs: { xs: "12" } },
                                      [
                                        _c(
                                          "w-row",
                                          [
                                            _c("w-input", {
                                              style: {
                                                flexGrow: 1,
                                                marginRight: "5px",
                                              },
                                              attrs: {
                                                label: _vm.$ct("heading-num", {
                                                  num: i + 1,
                                                }),
                                                fancy: "",
                                              },
                                              model: {
                                                value: heading.Value,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    heading,
                                                    "Value",
                                                    $$v
                                                  )
                                                },
                                                expression: "heading.Value",
                                              },
                                            }),
                                            _c(
                                              "w-button",
                                              {
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.editStyle(
                                                      heading.Style
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("w-fa", {
                                                  attrs: { icon: "font" },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-modal",
                {
                  attrs: { value: _vm.toEditStyle != null },
                  on: {
                    input: function ($event) {
                      return _vm.closeEditStyle($event)
                    },
                  },
                },
                [
                  _vm.toEditStyle
                    ? _c("app-style-editor", {
                        attrs: { value: _vm.toEditStyle },
                        on: {
                          close: function ($event) {
                            return _vm.closeEditStyle(false)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }